import { render, staticRenderFns } from "./ModalAlertPendingSkills.vue?vue&type=template&id=3affc6f8&scoped=true&"
import script from "./ModalAlertPendingSkills.vue?vue&type=script&lang=js&"
export * from "./ModalAlertPendingSkills.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertPendingSkills.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalAlertPendingSkills.vue?vue&type=style&index=1&id=3affc6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3affc6f8",
  null
  
)

export default component.exports